export const COURSE_TRANSFER = '/course/transfer'
